import { AfterViewInit, ChangeDetectionStrategy, Component, forwardRef, ViewEncapsulation } from "@angular/core";
import { InputFormWrapper } from "../wrapper.interface";
import { InputTextareaConfig } from "./input-textarea.config";
import { FormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { V_FORM_CONTROL_TOKEN, WRAPPER_TOKEN } from "../wrapper.tokens";
import { TranslateModule } from "@ngx-translate/core";
import { Textarea } from "primeng/textarea";

@Component({
    selector:    'v-input-textarea',
    templateUrl: './input-textarea.component.haml',
    styleUrls:   ['./input-textarea.component.sass', '../input.style.sass'],
    providers:   [
        { provide: V_FORM_CONTROL_TOKEN, useExisting: forwardRef(() => VInputTextareaComponent) },
        { provide: WRAPPER_TOKEN, useExisting: forwardRef(() => VInputTextareaComponent) },
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => VInputTextareaComponent), multi: true }
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation:   ViewEncapsulation.None,
    imports:         [CommonModule, Textarea, ReactiveFormsModule, TranslateModule]
})
export class VInputTextareaComponent extends InputFormWrapper<InputTextareaConfig, string> implements AfterViewInit {
    protected readonly _baseConfig: InputTextareaConfig = InputTextareaConfig.baseTheme.Default;
    async ngAfterViewInit(){
        // prevents value change after check warning
        await null;
        this.setMaxLength();
    }

    writeValue(value: string): void {
        if (this.config().maxlength) value = value?.substring(0, this.config().maxlength);
        super.writeValue(value);
    }

    setMaxLength(): void {
        const validator = this.formControlDirective()?.form?.validator;
        if (!validator) return;
        const errors = validator(new FormControl({length: Infinity}));
        const length = errors?.maxlength.requiredLength;
        if (length)this.config().maxlength = length;
    }
}